module.exports = __webpack_public_path__ + "media/images/instagram-a2cf01016ab5a6b3ea90b7edda2feadf.svg";